import GalleryList from "~/components/GalleryList";
import { getLink, trans } from "~/providers/lang";
import { ROUTES } from "~/const";
import { useSeo } from "~/hooks/useSeo";
import { mainStore } from "~/stores/main";

export default function GalleryWeddingPage() {
	useSeo({
		title: trans("skelet.title.formal"),
		canonical: "galerie-spolecenske-saty",
	});

	const pageData = mainStore(state => state.data.pageData);
	const source = pageData.photos.formal;

	return <GalleryList baseUrl={getLink(ROUTES.galleryFormal)} title={trans("template.formal")} source={source} />;
}
